import React, { ButtonHTMLAttributes, memo } from 'react';
import { IconButtonType } from '../../libraries/IconButtonTheme';
import { TooltipPosition } from '../../libraries/Tooltips';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './IconButton.scss';
const rootClassName = 'component-icon-button';

export interface IconButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  'tooltip-position'?: TooltipPosition;
  'tooltip-text'?: string;
  icon?: string | React.ReactNode;
  theme?: IconButtonType;
  disabled?: boolean;
  className?: string;
}

function IconButton(props: IconButtonProps) {
  const handleClick = (evt: any) => {
    if (!props.disabled) {
      props.onClick?.(evt);
    }
  };

  const getProps = () => {
    const p: any = {
      ...props,
      onClick: handleClick,
      className: getMergedClassNames([
        rootClassName,
        props.className,
        `${rootClassName}-${props.theme}`,
      ]),
    };
    delete p.icon;
    delete p.children;
    delete p.theme;
    delete p.w100;
    return p;
  };

  return <button {...getProps()}>{props.icon}</button>;
}

IconButton.defaultProps = {
  theme: 'primary',
  disabled: false,
  icon: '-',
};

export default memo(IconButton);
